// extracted by mini-css-extract-plugin
module.exports = {"add-to-cart":"AddToCart_add-to-cart__GGLWX","success":"AddToCart_success__1nHGe","error":"AddToCart_error__rBKMW"};